/**
 * Custom controls for Product video section (Shopify Files / HTML5 only).
 */
(function () {
  function formatTime(sec) {
    if (!sec || !isFinite(sec)) return '0:00';
    var s = Math.floor(sec % 60);
    var m = Math.floor(sec / 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initPlayer(root) {
    var video = root.querySelector('video');
    if (!video || root.getAttribute('data-pvl-ready')) return;
    root.setAttribute('data-pvl-ready', 'true');

    var overlay = root.querySelector('[data-pvl-overlay]');
    var bar = root.querySelector('[data-pvl-bar]');
    var btnPlayToggle = root.querySelector('[data-pvl-play-toggle]');
    var btnMute = root.querySelector('[data-pvl-mute]');
    var inpVol = root.querySelector('[data-pvl-volume]');
    var inpSeek = root.querySelector('[data-pvl-seek]');
    var timeCur = root.querySelector('[data-pvl-time-current]');
    var timeRem = root.querySelector('[data-pvl-time-remain]');
    var btnRate = root.querySelector('[data-pvl-rate]');
    var btnFs = root.querySelector('[data-pvl-fs]');

    var rates = [0.75, 1, 1.25, 1.5, 2];
    var rateIndex = 1;

    function setPlaying(playing) {
      root.classList.toggle('is-playing', playing);
      if (overlay) overlay.hidden = playing;
      if (bar) bar.hidden = !playing;
      if (btnPlayToggle)
        btnPlayToggle.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }

    function updateSeekVisual() {
      var d = video.duration;
      if (!d || !isFinite(d)) return;
      var pct = (video.currentTime / d) * 100;
      if (inpSeek) {
        inpSeek.value = String(pct);
        inpSeek.style.setProperty('--pct', pct + '%');
      }
      if (timeCur) timeCur.textContent = formatTime(video.currentTime);
      if (timeRem) timeRem.textContent = '-' + formatTime(Math.max(0, d - video.currentTime));
    }

    if (inpSeek) {
      inpSeek.style.setProperty('--pct', '0%');
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        video
          .play()
          .then(function () {
            setPlaying(true);
          })
          .catch(function () {});
      });
    }

    if (btnPlayToggle) {
      btnPlayToggle.addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    if (btnMute) {
      btnMute.addEventListener('click', function () {
        if (video.muted) {
          video.muted = false;
          if (video.volume === 0) {
            video.volume = 1;
            if (inpVol) inpVol.value = '1';
          }
        } else {
          video.muted = true;
        }
        if (inpVol) inpVol.value = String(video.muted ? 0 : video.volume);
        root.classList.toggle('is-muted', video.muted);
      });
    }

    if (inpVol) {
      inpVol.addEventListener('input', function () {
        var v = Number(inpVol.value);
        video.volume = v;
        video.muted = v === 0;
        root.classList.toggle('is-muted', video.muted);
      });
    }

    if (inpSeek) {
      inpSeek.addEventListener('input', function () {
        var d = video.duration;
        if (!d || !isFinite(d)) return;
        var pct = Number(inpSeek.value);
        video.currentTime = (pct / 100) * d;
        inpSeek.style.setProperty('--pct', pct + '%');
      });
      inpSeek.addEventListener('mousedown', function (e) {
        e.stopPropagation();
      });
      inpSeek.addEventListener('touchstart', function (e) {
        e.stopPropagation();
      }, { passive: true });
    }

    if (btnRate) {
      btnRate.addEventListener('click', function () {
        rateIndex = (rateIndex + 1) % rates.length;
        var r = rates[rateIndex];
        video.playbackRate = r;
        btnRate.textContent = r % 1 === 0 ? r + 'x' : r + 'x';
      });
    }

    if (btnFs) {
      btnFs.addEventListener('click', function () {
        var doc = document;
        var el = root;
        if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
          if (el.requestFullscreen) el.requestFullscreen();
          else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
        } else {
          if (doc.exitFullscreen) doc.exitFullscreen();
          else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
        }
      });
    }

    video.addEventListener('play', function () {
      setPlaying(true);
    });
    video.addEventListener('pause', function () {
      setPlaying(false);
    });
    video.addEventListener('timeupdate', updateSeekVisual);
    video.addEventListener('loadedmetadata', function () {
      if (inpSeek) inpSeek.max = '100';
      updateSeekVisual();
    });
    video.addEventListener('ended', function () {
      setPlaying(false);
    });

    video.addEventListener('click', function (e) {
      if (e.target !== video) return;
      if (!root.classList.contains('is-playing')) return;
      video.pause();
    });

    root.classList.toggle('is-muted', video.muted);
    if (inpVol) {
      inpVol.value = video.muted ? '0' : String(video.volume);
    }
    setPlaying(!video.paused);
  }

  function initUrlEmbed(root) {
    if (!root || root.getAttribute('data-pvl-url-ready')) return;
    var poster = root.querySelector('[data-pvl-url-poster]');
    var iframe = root.querySelector('iframe[data-pvl-embed-src]');
    if (!poster || !iframe) return;
    var src = iframe.getAttribute('data-pvl-embed-src');
    if (!src) return;
    root.setAttribute('data-pvl-url-ready', 'true');
    poster.addEventListener('click', function () {
      iframe.setAttribute('src', src);
      poster.setAttribute('hidden', '');
    });
  }

  function scan(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-product-video-player]').forEach(initPlayer);
    scope.querySelectorAll('[data-pvl-url-embed]').forEach(initUrlEmbed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) scan(event.target);
  });
})();
